/**
 * Convert a UTC timestamp to a string
 * @param rawDate - The UTC timestamp with milliseconds to convert (eg: 2026-01-01T00:00:00.000Z)
 * @returns The formatted date string (eg: "January 1, 2026")
 */
export function UTCtimestampToString(rawDate: Date | undefined | null): string {
  const date = new Date(rawDate ?? "");
  if (isNaN(date.getTime())) {
    return "Invalid date";
  }

  return date.toLocaleDateString("en-US", {
    year: "numeric",
    month: "long",
    day: "numeric",
    timeZone: "UTC",
  });
}
